import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AuthView from "@/views/AuthView.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import AllTasksView from "@/views/AllTasksView.vue";
import MyTasksView from "@/views/MyTasksView.vue";
import UsersView from "@/views/UsersView.vue";
import CompanyView from "@/views/Company/CompanyView.vue";
import CompanyChildView from "@/views/Company/CompanyChildView.vue";
import DriversView from "@/views/DriversView.vue";
import ShiftView from "@/views/ShiftView.vue";
import ArchiveView from "@/views/ArchiveView.vue";
import WorkingView from "@/views/WorkingView.vue";
import { getToken } from "@/utils/token";
import { userService } from "@/features/users/user.service";
import InspectionsView from "@/views/InspectionsView.vue";
import UnauthorizedView from "@/views/Error/UnauthorizedView.vue";
import PermissionView from "@/views/Error/PermissionView.vue";
import NotFoundView from "@/views/Error/NotFoundView.vue";
import ErrorView from "@/views/Error/ErrorView.vue";
import DriverStatusView from "@/views/DriverStatusView.vue";
import LiveStatsView from "@/views/LiveStatsView.vue";
import WorkScheduleView from "@/views/WorkScheduleView.vue";
import ProfileView from "@/views/ProfileView.vue";
import ProviderView from "@/views/ProviderView.vue";
import ManagementView from "@/views/ManagementView.vue";
import OrganizationView from "@/views/OrganizationView.vue";
import CheckView from "@/views/Check/CheckView.vue";
import CheckChildView from "@/views/Check/CheckChildView.vue";
import OrganizationLayout from "@/layouts/OrganizationLayout.vue";

const routes = [
  {
    path: "/auth",
    component: AuthLayout,
    meta: { guest: true },
    children: [
      {
        path: "",
        name: "SignIn",
        component: AuthView,
      },
    ],
  },

  {
    path: "/organization",
    component: OrganizationLayout,
    meta: { requiresAuth: true, superAdminOnly: true },
    children: [
      {
        path: "",
        name: "Organization",
        component: OrganizationView,
      },
    ],
  },

  {
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Overview",
        component: HomeView,
      },
      {
        path: "all-tasks",
        name: "all-tasks",
        component: AllTasksView,
      },
      {
        path: "my-tasks",
        name: "my-tasks",
        component: MyTasksView,
      },
      {
        path: "users",
        name: "users",
        component: UsersView,
      },
      {
        path: "work-schedule",
        name: "work schedule",
        component: WorkScheduleView,
      },
      {
        path: "companies",
        name: "companies",
        component: CompanyView,
      },
      {
        path: "/companies/:id",
        name: "companies-child",
        component: CompanyChildView,
      },
      {
        path: "drivers",
        name: "drivers",
        component: DriversView,
      },
      {
        path: "shift",
        name: "shift",
        component: ShiftView,
      },
      {
        path: "work-types",
        name: "work types",
        component: WorkingView,
      },
      {
        path: "archive",
        name: "archive",
        component: ArchiveView,
      },
      {
        path: "inspections",
        name: "inspections",
        component: InspectionsView,
      },
      {
        path: "watch-list",
        name: "Watch list",
        component: DriverStatusView,
      },
      {
        path: "live-stats",
        name: "Live statistics",
        component: LiveStatsView,
      },
      {
        path: "profile",
        name: "Profile",
        component: ProfileView,
      },
      {
        path: "provider",
        name: "Provider",
        component: ProviderView,
      },
      {
        path: "management",
        name: "Management",
        component: ManagementView,
      },
      // {
      //   path: "organizations",
      //   name: "Organizations",
      //   component: OrganizationView,
      // },
      {
        path: "reviews",
        name: "Reviews",
        component: CheckView,
      },
      {
        path: "reviews/:id",
        name: "Reviews-child",
        component: CheckChildView,
      },
    ],
  },
  {
    path: "/401",
    name: "401",
    component: UnauthorizedView,
  },
  {
    path: "/402",
    name: "402",
    component: PermissionView,
  },
  {
    path: "/403",
    name: "403",
    component: PermissionView,
  },
  {
    path: "/404",
    name: "404",
    component: NotFoundView,
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to: any) => {
  const token = getToken();

  if (!token) {
    if (to.meta.requiresAuth || to.path === "/") {
      return "/auth";
    }

    return true;
  }

  // Public error pages don't need profile verification.
  if (["/401", "/402", "/403", "/404", "/error-page"].includes(to.path)) {
    return true;
  }

  try {
    const { data: profile } = await userService.getUserProfile();

    const isSuperAdmin = profile.role === "super_admin";

    if (!isSuperAdmin) {
      if (!profile.organization_id) {
        return "/403";
      }

      localStorage.setItem("organizationId", profile.organization_id);
    }

    const homePage = isSuperAdmin ? "/organization" : "/all-tasks";

    if (to.path === "/" || to.meta.guest) {
      return homePage;
    }

    if (to.meta.superAdminOnly && !isSuperAdmin) {
      return "/all-tasks";
    }

    return true;
  } catch {
    return "/401";
  }
});

export default router;
